<div class="scheduler-toggle">
    <mat-checkbox [ngModel]="schedulerEnabled" color="primary" (change)="toggleScheduler()">
        {{schedulerEnabled ? 'Scheduler attivo' : 'Scheduler non attivo'}}
    </mat-checkbox>
</div>
<div class="week-days" *ngIf="schedulerEnabled">
    <div class="week-day" *ngFor="let weekDay of ORDERED_WEEK_DAYS">
        <div class="day-info">
            <mat-icon>calendar_today</mat-icon>
            {{WeekDaysEnum[weekDay]}}
        </div>
        <div class="schedule">
            <div class="day-schedule">
                <div>Fasce orarie</div>
                <div class="time-schedule" *ngFor="let scheduleItem of schedulerConfig[weekDay].schedule; let scheduleItemIndex = index">
                    <mat-form-field appearance="outline">
                        <mat-label>Dalle</mat-label>
                        <input type="time" matInput placeholder="00:00" [(ngModel)]="scheduleItem.startHour" />
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label>Alle</mat-label>
                        <input type="time" matInput placeholder="01:00" [(ngModel)]="scheduleItem.endHour" />
                    </mat-form-field>
                    <button mat-button aria-label="Remove time slot" (click)="removeTimeSlot(weekDay, scheduleItemIndex)">
                        Rimuovi fascia oraria
                    </button>
                </div>
                <div class="schedule-actions">
                    <button mat-raised-button color="primary" aria-label="Add time slot" (click)="addTimeSlot(weekDay)">Aggiungi fascia oraria</button>
                    <button mat-raised-button color="primary" (click)="replicateSchedule(weekDay)">Replica</button>
                </div>
            </div>
            <div class="birthday-schedule">
                <div>Fasce orarie compleanno</div>
                <ng-container *ngIf="schedulerConfig[weekDay].birthday">
                    <mat-form-field appearance="outline">
                        <mat-label>Data</mat-label>
                        <input matInput [matDatepicker]="picker" [(ngModel)]="schedulerConfig[weekDay].birthday.date">
                        <mat-hint>DD/MM/YYYY</mat-hint>
                        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                    <div class="time-schedule" *ngFor="let birthdayScheduleItem of schedulerConfig[weekDay].birthday.schedule; let birthdayScheduleIndex = index">
                        <mat-form-field appearance="outline">
                            <mat-label>Dalle</mat-label>
                            <input type="time" matInput placeholder="00:00" [(ngModel)]="birthdayScheduleItem.startHour" />
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                            <mat-label>Alle</mat-label>
                            <input type="time" matInput placeholder="01:00" [(ngModel)]="birthdayScheduleItem.endHour" />
                        </mat-form-field>
                        <button mat-button aria-label="Remove birthday time slot" (click)="removeBirthdayTimeSlot(weekDay, birthdayScheduleIndex)">
                            Rimuovi fascia oraria
                        </button>
                    </div>
                </ng-container>
                <div class="schedule-actions">
                    <ng-container *ngIf="schedulerConfig[weekDay].birthday">
                        <button mat-raised-button color="primary" aria-label="Add birthday time slot" (click)="addBirthdayTimeSlot(weekDay)">Aggiungi fascia oraria</button>
                        <button mat-button aria-label="Remove birthday" (click)="removeBirthday(weekDay)">Rimuovi compleanno</button>
                    </ng-container>
                    <button mat-raised-button color="accent" aria-label="Add birthday" (click)="addBirthday(weekDay)" *ngIf="!schedulerConfig[weekDay].birthday">Aggiungi compleanno</button>
                </div>
            </div>
        </div>
    </div>
</div>
